<template>
    <Toast />
	<div class="grid nested-grid">
		<div class="col-12">
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">{{ translated('companyCommunicationTitle').toUpperCase() }}</h5>
				</div>												
			</div>	      
            <DataTable stateStorage="local" stateKey="dt-state-companies-communication" :value="companies" class="p-datatable-sm" removableSort :resizableColumns="true" showGridlines dataKey="id" 
            v-model:filters="filters1" :loading="loading1" responsiveLayout="scroll" :rowHover="true"
            :globalFilterFields="['Name','Street','City','Komunikacija','CpoId','MspId','RpoId','RspId']"
            :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,30,50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <template #header>
                        <div class="flex p-jc-end">
                            <span class="p-input-icon-right ">
                                <i class="pi pi-search" />
                                <InputText v-model="filters1['global'].value" :placeholder="translated('keywordsearch')" />
                            </span>
                        </div>
                    </template>        
                    <template #empty>
                        No companies found.
                    </template>
                    <template #loading>
                        Loading companies data. Please wait.
                    </template>    

                <Column field="IsOperator" :header="translated('cpotable')" bodyClass="p-text-center" >
                    <template #body="{data}">
                        {{ data.CpoId }}
                    </template>
                </Column>

                <Column field="IsServiceprovider" :header="translated('msptable')" bodyClass="p-text-center" >
                    <template #body="{data}">
                        {{ data.MspId }}             
                    </template>
                </Column>

                <Column field="IsRpo" :header="translated('rpotable')" bodyClass="p-text-center" >
                    <template #body="{data}">
                        {{ data.RpoId }}              
                    </template>
                </Column>

                <Column field="IsRsp" :header="translated('rsptable')" bodyClass="p-text-center" >
                    <template #body="{data}">
                        {{ data.RspId }}                    
                    </template>
                </Column>

                <Column :header="translated('companyname')" field="Name" :sortable="true" ></Column>

                <Column :header="translated('street')" >
                    <template #body="{data}">
                        {{ (data.Street ?? '') + ' ' + (data.Housenumber ?? '') }}                  
                    </template>            
                </Column>            

                <Column :header="translated('zipcity')" >
                    <template #body="{data}">
                        {{ (data.Zip ?? '') + ' ' + (data.City ?? '') }}                  
                    </template>             
                </Column>

                <Column field="Komunikacija" :header="translated('communicationtable')" >
                    <template #body="{data}">
                        {{ data.Komunikacija || '—' }}                  
                    </template>             
                </Column>

                <Column field="ZadnjaSinhronizacija" :header="translated('lastsynctable')" >
                    <template #body="{data}">
                        {{ formatDate(data.ZadnjaSinhronizacija) || '—' }}                  
                    </template>             
                </Column>
            </DataTable>
        </div>
    </div>  
</template>

<script>
import {FilterMatchMode} from 'primevue/api';
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";

// Pregled komunikacije: spisek potrjenih podjetij z načinom komuniciranja in zadnjo sinhronizacijo.
export default {
  data() {
    return {
        translated: computed(() => store.getters.getTranslate),
        companies: null,
        filters1: null,
        loading1: true
    }
  },   
  created() {
      this.initFilters1();
  }, 
  async mounted() {           
      this.LoadData();
  },
  methods: {
      clearFilter1() {
          this.initFilters1();
      },
      initFilters1() {
          this.filters1 = {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
          }
      },
      async LoadData() {
        const http = createHttp(true);
        const myUrl = process.env.VUE_APP_API_FOLDER + "/GetCompaniesCommunication";
        console.log(myUrl);

        const result = await http.get(myUrl);

        if(result.status==200){
            this.companies = result.data
        }

        this.loading1 = false
      },
      formatDate(dateTime) {
          if (!dateTime) {
              return '';
          }

          const d = new Date(dateTime);
          return d.toLocaleString('sl-SI', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
          });
      }
  }  
}
</script>

<style scoped>
</style>
